export enum EmailVerificationMethod {
  magicLinkVerification,
  OTPVerification,
}

export interface PendingOperationConfig {
  paths: {
    _root: string
    confirmMobile: string
    changeMobile: string
    emailSelection: string
    confirmEmail: string
    externalConfirmEmail: string
    needAcceptConsents: string
    changePassword: string
    infoSharing: string
    migration: {
      _root: string
      needInsertPhone: string
      confirmPhone: string
    }
    externalMatching: {
      _root: string
      confirmEmail: string
      verifyEmail: string
      confirmMobile: string
      verifyMobile: string
    }
    emailVerification: {
      _root: string
      oldLink: string
      alreadyVerified: string
    }
  }
  emailVerificationMethod: EmailVerificationMethod
}
